import React, { useState, useCallback } from 'react';
import Header from './Header';
import Sidebar from './Sidebar';
import Footer from './Footer';

function Layout({ children }) {
  const [collapsed, setCollapsed] = useState(() => {
    return localStorage.getItem('sidebar-collapsed') === 'true';
  });

  const toggleSidebar = useCallback(() => {
    setCollapsed(prev => {
      const next = !prev;
      localStorage.setItem('sidebar-collapsed', String(next));
      return next;
    });
  }, []);

  return (
    <div className="d-flex">
      <Sidebar collapsed={collapsed} onToggle={toggleSidebar} />
      <div
        className="flex-grow-1"
        style={{
          marginLeft: collapsed ? '60px' : '250px',
          transition: 'margin-left 0.2s ease',
        }}
      >
        <Header />
        <main className="p-4" style={{ minHeight: 'calc(100vh - 120px)' }}>
          {children}
        </main>
        <Footer />
      </div>
    </div>
  );
}

export default Layout;
